<template>
  <div class="error404">
    <header-main></header-main>
    <header class="error">
      <h5>Ups...</h5>
      <h6>Coś poszło nie tak...</h6>
    </header>
    <footer-main></footer-main>
    <nav-mobile></nav-mobile>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'
import NavMobile from '@/components/NavMobile.vue'

export default {
  name: 'Error404',
  components: {
    HeaderMain,
    FooterMain,
    NavMobile
  }
}
</script>
<style scoped lang="scss">
  div.error404 { display: flex; flex-direction: column; justify-content: center; height: 100%; padding-top: 60px; }
  header.error { height: 342px; margin: auto; padding-left: 130px; background: url('../assets/error404.webp') no-repeat 0% 50%; }
  header.error h5 { margin: 0; padding: 0; font-size: 40px; font-weight: 500; color: $fontBlack; }
  header.error h6 { margin: 0; padding: 0; font-size: 20px; font-weight: 400; color: $fontGray; }

  @media (max-width: 350px) {
    header.error { width: 100vw; height: 500px; padding: 0; }
    header.error h5 { text-align: center; }
    header.error h6 { text-align: center;  }
  }
</style>
